import request from '@/utils/request'

let SizeApi = {

  /*尺码管理列表*/
  list(data) {
    return request._post('/shop/plus.size.Index/index', data);
},
/*添加尺码管理*/
add(data) {
    return request._post('/shop/plus.size.Index/add', data);
},
/*修改尺码管理*/
edit(data) {
    return request._post('/shop/plus.size.Index/edit', data);
},
/*删除尺码管理*/
del(data) {
    return request._post('/shop/plus.size.Index/del', data);
},
/*尺码管理详情*/
detail(data) {
  return request._post('/shop/plus.size.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.size.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.size.Setting/getSetting', data, errorback);
    },
}
export default SizeApi;



// WEBPACK FOOTER //
// ./src/api/size.js